import React, { FC, useState } from 'react';

const As2PartnersGuide: FC = () => {
    const [open, setOpen] = useState(false);

    return (
        <div className="rounded-md border border-slate-200 bg-slate-50 text-sm text-slate-700">
            <button
                type="button"
                className="flex w-full items-center justify-between px-3 py-2 font-medium text-slate-800 hover:bg-slate-100"
                onClick={() => setOpen((v) => !v)}
            >
                Partner actions guide
                <span className="text-xs text-slate-500">{open ? 'Hide' : 'Show'}</span>
            </button>
            {open && (
                <div className="space-y-2 border-t border-slate-200 px-3 py-3 text-xs">
                    <table className="w-full text-left">
                        <thead>
                            <tr className="border-b border-slate-200 text-slate-500">
                                <th className="py-1 pr-3 font-medium">Action</th>
                                <th className="py-1">What it does</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-100">
                            <tr>
                                <td className="py-1.5 pr-3 align-top font-medium text-slate-800">Test URL</td>
                                <td className="py-1.5">
                                    HTTPS reachability to the partner receive URL only — not an AS2 message send.
                                </td>
                            </tr>
                            <tr>
                                <td className="py-1.5 pr-3 align-top font-medium text-slate-800">Send test EPCIS</td>
                                <td className="py-1.5">
                                    Real OpenAS2 dispatch (panel above). Pick EPCIS from the dropdown, then check{' '}
                                    <strong>Messages</strong> for MDN status.
                                </td>
                            </tr>
                            <tr>
                                <td className="py-1.5 pr-3 align-top font-medium text-slate-800">Cert</td>
                                <td className="py-1.5">
                                    Download reference X.509 from the server or upload in Edit / Setup wizard.
                                </td>
                            </tr>
                            <tr>
                                <td className="py-1.5 pr-3 align-top font-medium text-slate-800">Row details</td>
                                <td className="py-1.5">
                                    Expand a row for routes, cert metadata, and URLs. Long values show{' '}
                                    <strong>Show full text</strong>.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default As2PartnersGuide;
